import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { IconSquareX } from '@tabler/icons-react';
import { Form, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';

import styles from './UploadImage.module.scss';

function UploadImage({
    required,
    cropShape,
    label,
    name,
    formItemProps,
    aspect,
    objectName = '',
    description = '',
    uploadApi = apiConfig.file.upload,
    type = 'AVATAR',
}) {
    return (
        <Form.Item
            {...formItemProps}
            required={required}
            label={label}
            name={name}
            rules={[
                {
                    required: required,
                    message: '',
                },
            ]}
        >
            <ImageField
                uploadApi={uploadApi}
                cropShape={cropShape}
                objectName={objectName}
                aspect={aspect}
                description={description}
                type={type}
            />
        </Form.Item>
    );
}

function ImageField({ value = '', cropShape, onChange, objectName = '', aspect, description, uploadApi, type }) {
    const { execute: executeUpFile } = useFetch(uploadApi);
    const [ hoverItem, setHoverItem ] = useState(false);
    const translate = useTranslate();

    const uploadFile = ({ file, onSuccess }) => {
        executeUpFile({
            data: {
                type: type,
                file: file,
            },
            onCompleted: (result) => {
                const relativePath = result.data.filePath;
                onChange(relativePath);
                onSuccess();
            },
            onError: (error) => {},
        });
    };

    const handleRemoveImage = (e) => {
        e.stopPropagation();
        onChange('');
    };

    const renderContent = () => {
        if (value) {
            const displayUrl = `${AppConstants.contentRootUrl}${value}`;
            return (
                <div
                    style={{ position: 'relative', width: '92px', height: '92px' }}
                    onMouseMove={() => setHoverItem(true)}
                    onMouseLeave={() => setHoverItem(false)}
                >
                    <img className={styles['img-uploaded']} src={displayUrl} alt="uploaded-image" />
                    {/* {hoverItem && (
                        <IconSquareX
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                color: 'white',
                                fill: 'red',
                                width: 30,
                                height: 30,
                            }}
                            onClick={handleRemoveImage}
                            onMouseMove={() => setHoverItem(true)}
                            onMouseLeave={() => setHoverItem(false)}
                        />
                    )} */}
                </div>
            );
        }
        return (
            <div className={styles['upload-wrapper']}>
                <PlusOutlined style={{ fontSize: 16 }} />
                <div className={styles['upload-text']}>{translate.formatMessage(commonMessage.upload)} {objectName}</div>
            </div>
        );
    };

    return (
        <div
            style={{
                display: 'flex',
                gap: 10,
                alignItems: 'center',
                justifyContent: 'center',
                width: '102px',
                height: '102px',
                border: '1px dashed #d9d9d9',
                padding: '8px',
                borderRadius: '8px',
                cursor: 'pointer',
            }}
        >
            <div className={styles['avatar-uploader']}>
                <ImgCrop cropShape={cropShape} aspect={aspect}>
                    <Upload accept=".jpg, .jpeg, .png" showUploadList={false} customRequest={uploadFile}>
                        {renderContent()}
                    </Upload>
                </ImgCrop>
            </div>
            {description && <span style={{ marginLeft: 20, maxWidth: 300 }}>{description}</span>}
        </div>
    );
}

export default UploadImage;
